export enum OrderStatus {
  OPEN = "OPEN",
  COMPLETED = "COMPLETED",
  CANCELED = "CANCELED",
}
